import React from "react";
import moment from "moment";
import A12Y_CONST from "../common/a12yConst";
import Loading from "./LoadingComponent";

const CheckIcon = () => (
    <svg className="ots__feature-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const OneTimeActivationPopup = ({ isOpen, onClose, onProceed, dependentName, activationFee, excemptAllFee, loading, subscription, currentCount = 0, proratedAmount = 0, nextBill = 0 }) => {
    if (!isOpen) return null;

    const planAmount = subscription?.price_details?.plan_amount || 0;
    const planInterval = subscription?.price_details?.plan_interval_display || '';
    const renewalDate = subscription?.renewal_date || subscription?.subscription_details?.renewal_date;
    const nextBillFormatted = renewalDate ? moment(new Date(renewalDate)).format('MMMM D, YYYY') : '';
    const isTrialing = subscription?.trial_period === true && 
        (subscription?.status?.toLowerCase() === "trialing" || 
         subscription?.subscription_details?.subscription_status?.toLowerCase() === "trialing");

    const percentOff = subscription?.price_details?.percent_off;
    const amountOff = subscription?.price_details?.amount_off;
    const hasDiscount = (percentOff != null && percentOff > 0) || (amountOff != null && amountOff > 0);
    const discountText = amountOff ? ` $${amountOff.toFixed(2)} Discount` : percentOff ? `($${((planAmount * percentOff / 100) * (currentCount + 1)).toFixed(2)}) | ${percentOff}% Discount` : '';
    const totalamount =  Number(proratedAmount) + Number(activationFee)
    return (
        <div className='popTop ndcPopup__overlay'>
            <div className='popContainer popMaxWidth ots-popup__container-custom'>
                <div className='popMaster'>
                    <div className="popUpMainBg fullWidth ndcPopup__body">
                        <button className="ots-popup__close-custom" onClick={onClose}>&times;</button>

                        {/* Icon */}
                        <div className="cancelIcon fullWidth marginTopBottom20">
                            <svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 82 82" fill="none">
                                <rect x="37.1328" y="19.3396" width="7.73585" height="31.717" fill="#2d6cb2" />
                                <circle cx="40.9999" cy="60.3395" r="4.64151" fill="#2d6cb2" />
                                <path fillRule="evenodd" clipRule="evenodd"
                                    d="M41 82C63.6437 82 82 63.6437 82 41C82 18.3563 63.6437 0 41 0C18.3563 0 0 18.3563 0 41C0 63.6437 18.3563 82 41 82ZM40.9996 75.0378C59.7982 75.0378 75.0374 59.7986 75.0374 41.0001C75.0374 22.2016 59.7982 6.96235 40.9996 6.96235C22.2011 6.96235 6.96191 22.2016 6.96191 41.0001C6.96191 59.7986 22.2011 75.0378 40.9996 75.0378Z"
                                    fill="#2d6cb2" />
                            </svg>
                        </div>

                        {/* Title */}
                        <div className="areYouText areYouDmFont texAlingCener">Reactivate Dependent</div>

                        
                        {/* Description */}
                        <div className="useInfo ndcPopup__subtitle">
                            Reactivating a dependent will adjust your Advocord subscription. You will be charged a pro-rated monthly amount and one-time reactivation fee:
                        </div>

                        {/* Pro-rated amount */}
                        <div className="fullWidth texAlingCener marginTop15 marginBottom5 ndcPopup__amount">
                            Pro-Rated Amount: ${proratedAmount.toFixed(2)}
                        </div>
                        <div className="fullWidth texAlingCener marginTop15 marginBottom15 ndcPopup__amount">
                            Reactivation Fee: ${activationFee}
                            {(excemptAllFee && activationFee) && (
                                '$0'
                            )}
                        </div>

                        {/* Next bill info */}
                        <div className="useInfo ndcPopup__subtitle">
                            Your next bill on {nextBillFormatted} will adjust to:
                        </div>

                        {/* Plan Details Section */}
                        <div className="fullWidth marginTop20 ndcPopup__details">
                            {/* <div className="ndcPopup__row">
                                <div className="ndcPopup__label">Plan Details</div>
                                <div className="ndcPopup__value">
                                    <div className="ndcPopup__planBox ndcPopup__planBox--warm">
                                        {planInterval} ${planAmount}
                                    </div>
                                    <div className="ndcPopup__planNote">
                                        Prices are mentioned in US currency and do not include applicable taxes
                                    </div>
                                </div>
                            </div> */}

                            <div className="ndcPopup__row ndcPopup__row--center">
                                <div className="ndcPopup__label">Active Dependents</div>
                                <div className="ndcPopup__countBox ndcPopup__countBox--green">
                                    {currentCount + 1}
                                </div>
                            </div>

                            {hasDiscount && (
                                <div className="ndcPopup__row ndcPopup__row--center">
                                    <div className="ndcPopup__label">Discount Applied:</div>
                                    <div className="ndcPopup__value ndcPopup__discountValue">{discountText}</div>
                                </div>
                            )}
                        </div>

                        {/* Total billed */}
                        <div className="fullWidth texAlingCener ndcPopup__totalBilled ndcPopup__totalBilled--warm">
                            ${totalamount.toFixed(2)} will be charged today
                        </div>

                        {/* Buttons */}
                        <div className="fullWidth marginTop20 texAlingCener df jcc aic">
                            <div
                                className={`popUpYesButton ${loading ? 'saveButtonDisable' : ''}`}
                                onClick={loading ? undefined : onClose}
                                style={loading ? { pointerEvents: 'none', opacity: 0.5, marginRight: '10px' } : { marginRight: '10px' }}
                            >
                                CANCEL
                            </div>
                            <div className="widthAuto">
                                <div className="loaderSpinner">
                                    {loading && <Loading />}
                                    <input
                                        id="EnableDependentBtn"
                                        className={loading ? "popUpNoButton marginLeftRight2percent saveButtonDisable" : "popUpNoButton marginLeftRight2percent"}
                                        disabled={loading}
                                        type="button"
                                        value="Enable Dependent"
                                        onClick={onProceed}
                                        style={{ border: 'none', margin: '0' }}
                                    />
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OneTimeActivationPopup;

